import React, { useState } from "react";
import Image, { ImageProps } from "next/image";
import { ShareImage } from "../../../models/ShareImage";
import CloudinaryService from "../../../services/CloudinaryService";

type Props = {
  image: ShareImage;
  cloudinaryTransformation: object;
  width: number | string;
  height: number | string;
  className: string;
  src?: string;
  format?: 'large' | 'medium' | 'small' | 'thumbnail'
};

const Img: React.FC<Props> = ({
  image,
  cloudinaryTransformation,
  src,
  format,
  ...rest
}) => {
  if (!image?.media?.url) return null;
  let local = false;
  let url = image.media.url;
  if (format && image.media.formats) {
    url = image.media.formats[format] ? image.media.formats[format].url : url;
  }
  if (url.includes("http")) {
    url = url;
  } else {
    local = true;
    url = `${process.env.NEXT_PUBLIC_LOCAL_IMG_DOMAIN}${url}`;
  }

  const imgSrc = local
    ? url
    : CloudinaryService.buildUrl(url, cloudinaryTransformation);

  return <Image src={src || imgSrc} alt={image.alt} {...rest} />;
};

export default Img;
